module.exports = "/_next/static/images/9402b93c9610151ed46f5fec1da694bf-woman-playing-with-her-kids@md.jpg.webp";